import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Container from "../../hoc/Container";
import ShopCart from "../../components/shop/shopCart";
import ShopRegionList from "../../components/shop/shopRegionList";
import { useDispatch } from "react-redux";
import NintendoInfo from "../../components/shop/nintendoInfo";
import { shouldOpenAccountLinkModal } from "../../components/shop/accountLinkBlock";
import { changeShop, receiveRegionList } from "../../store/order/actions";

const SHOP_TYPE = "eshop";

function NintendoShop() {
  const dispatch = useDispatch();
  const location = useLocation();
  const openAccountLinkModal = shouldOpenAccountLinkModal(location.search);

  useEffect(() => {
    dispatch(changeShop(SHOP_TYPE));
    dispatch(receiveRegionList(SHOP_TYPE));
  }, []);

  return (
    <Container>
      <section className="content-block mb-2">
        <h1 className="head-1">Карты Nintendo eShop</h1>
        <div className="shop-stack">
          <ShopRegionList shop={SHOP_TYPE} />
          <ShopCart shop={SHOP_TYPE} />
          <NintendoInfo openAccountLinkModal={openAccountLinkModal} />
        </div>
      </section>
    </Container>
  );
}

export default NintendoShop;
